/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Files_Delete_Dialog_Label_BulkInputs */

const es_settings_files_delete_dialog_label_bulk = /** @type {(inputs: Settings_Files_Delete_Dialog_Label_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archivos`)
};

const en_settings_files_delete_dialog_label_bulk = /** @type {(inputs: Settings_Files_Delete_Dialog_Label_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files`)
};

/**
* | output |
* | --- |
* | "{count} files" |
*
* @param {Settings_Files_Delete_Dialog_Label_BulkInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_delete_dialog_label_bulk = /** @type {((inputs: Settings_Files_Delete_Dialog_Label_BulkInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Delete_Dialog_Label_BulkInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_delete_dialog_label_bulk(inputs)
	return en_settings_files_delete_dialog_label_bulk(inputs)
});
export { settings_files_delete_dialog_label_bulk as "settings.files.delete_dialog.label_bulk" }